import commonMapping from "@/mapping/common";

const store_path_list = [{ value: "memory", label: "debug_sysmemory" }];

export const debug = {
  boot_up_collect_enable: commonMapping.intToBoolean,
  lan_wan_capture_enable: commonMapping.intToBoolean,
  store_path: store_path_list,
  ipv6_external_ping_enable: commonMapping.intToBoolean,
};

export default debug;
